import { API_ROUTE_TRADE_IN_ORDER_STATUS } from '@/resources/api-routes'
import { get } from '@/util/auth'

type OrderOriginal = {}

const IS_NEW_BACKEND_API = true

export const getTradeInOrderStatus = async (assetGuid: string) =>
  await get<{ departments: OrderOriginal[] }>(
    API_ROUTE_TRADE_IN_ORDER_STATUS.replace(':assetId', String(assetGuid)),
    IS_NEW_BACKEND_API
  )
